import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://192.168.100.52:5050/api",
      baseURL: "https://api.hms-pk.com/api",  

  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;